module.exports = __webpack_public_path__ + "img/dashboard-credit.095b1c01.png";